√<template>
    <div>
    <br/>
        <div v-if="customForm.hasOwnProperty('groups_append') && customForm.groups_append.length > 0">
            <div>
                <base-checkbox class="mb-3" v-model="menus.override_user_fields">User-defined Fields</base-checkbox>
            </div>
            <div style="padding-left: 35px;" v-if="menus.override_user_fields == true">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="menus" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                <!-- <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="userDefinedFields" :key="dynamicFormKey"/> -->
            </div>
        </div>
        <div v-else class="col-md-11">
            <p>No user-defined fields</p>
        </div>
    </div>
</template>

<script>

import HTTPRequest from '../controllers/httpRequest.js'
import DynamicForm from './DynamicForm.vue'
import { mapState, mapActions } from 'vuex'

var component_x;
export default {
    components: {
        DynamicForm
    },
    data: function(){
            return {
                menus: {},
                override_user_fields: false,
                customForm: {},
                userDefinedFilters: {},
                dynamicFormKey: 0,
                settingCode: null
            }
    },
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),
    },
    mounted: async function() {
        component_x = this;
        this.settingCode = this.$attrs.settingCode
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Products?field_name=name'  , null)
          const sytemModuleId = sytemModule.id
          const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
          if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
           const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
           if(accSystemModule != null){
               if(accSystemModule.form_mode != undefined){
                   this.customFormMode = accSystemModule.form_mode
               }
               if(accSystemModule.customized_forms != undefined){
                   this.customForm = accSystemModule.customized_forms
               }
           }
        }
          
        //   if(!(_.isEmpty(this.$attrs.parentParams)))
        //     this.userDefinedFilters = this.$attrs.parentParams
        this.dynamicFormKey++;
    },
    watch: {
        menus: {
            handler: async function() {
                var configValues = {}
                console.log("!!!!!!!")
                console.log(this.userDefinedFields);
                console.log(this.menus);
                this.menus.userDefinedFields = this.userDefinedFields
                configValues[this.settingCode] = this.menus
                component_x.$emit("changeValue", configValues)
            },
            deep: true
        }  
    },
    methods: {
        isJsonString(str) {
            try {
              var json = JSON.parse(str);
              return (typeof json === 'object');
            } catch (e) {
              return false;
            }
          },
          updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.menus
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.menus = mergedHash
            },
    }
}
</script>

